import React, { useState } from 'react';
import './formOrganization.css'
import { Form, Input, Button, Switch, Typography, Space, Row, Col, Checkbox, List, Tag } from 'antd';

const { Text } = Typography;

const FormOrganization = (props) => {
    const [isEditing, setIsEditing] = useState(false);

    const handleEditClick = () => setIsEditing(true);
    const handleSaveClick = () => {
        setIsEditing(false);
        props.editOrganization();  // Llama la función de guardado
    };

    const handleCheckboxChange = (ros_id, checked) => {
        if (!Array.isArray(props.orgServices)) return;

        props.setOrgServices((prevServices) =>
            Array.isArray(prevServices)
                ? prevServices.map(service =>
                    service.ros_id === ros_id
                        ? { ...service, ros_active: checked }
                        : service
                )
                : []
        );
        props.updateOrganizationService(ros_id, checked);
    };
    return (
        <Form layout="horizontal">
            {/* Nombre de la Organización */}
            <Row align="middle">
                <Col span={8}><strong>Nombre:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgName} onChange={(e) => props.setOrgName(e.target.value)} />
                    ) : (
                        <Text>{props.orgName || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Correo Electrónico */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Correo Electrónico:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgEmail} onChange={(e) => props.setOrgEmail(e.target.value)} />
                    ) : (
                        <Text>{props.orgEmail || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* NIT */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>NIT:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgNit} onChange={(e) => props.setOrgNit(e.target.value)} />
                    ) : (
                        <Text>{props.orgNit || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Sitio Web */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Sitio Web:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgWebsite} onChange={(e) => props.setOrgWebsite(e.target.value)} />
                    ) : (
                        <Text>{props.orgWebsite || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Número de Empleados */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Empleados:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input type="number" value={props.orgEmployees} onChange={(e) => props.setOrgEmployees(e.target.value)} />
                    ) : (
                        <Text>{props.orgEmployees || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Dirección */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Dirección:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgAddress} onChange={(e) => props.setOrgAddress(e.target.value)} />
                    ) : (
                        <Text>{props.orgAddress || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Responsable */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Responsable:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Space>
                            <Input value={props.orgResponsibleName} onChange={(e) => props.setOrgResponsibleName(e.target.value)} placeholder="Nombre" />
                            <Input value={props.orgResponsibleLastName} onChange={(e) => props.setOrgResponsibleLastName(e.target.value)} placeholder="Apellido" />
                        </Space>
                    ) : (
                        <Text>{`${props.orgResponsibleName || "No especificado"} ${props.orgResponsibleLastName || ""}`}</Text>
                    )}
                </Col>
            </Row>

            {/* Teléfono del Responsable */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Teléfono Responsable:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgResponsibleTel} onChange={(e) => props.setOrgResponsibleTel(e.target.value)} />
                    ) : (
                        <Text>{props.orgResponsibleTel || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Correo del Responsable */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Correo Responsable:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Input value={props.orgResponsibleEmail} onChange={(e) => props.setOrgResponsibleEmail(e.target.value)} />
                    ) : (
                        <Text>{props.orgResponsibleEmail || "No especificado"}</Text>
                    )}
                </Col>
            </Row>

            {/* Servicios activos */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Servicios activos:</strong></Col>
                <Col span={16}>
                    {isEditing && props.isSuperUser ? (
                        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                            {props.orgServices.map(service => (
                                <Row key={service.srv_id} align="middle" justify="space-between">
                                    <Col>{service.srv_service}</Col>
                                    <Col>
                                        <Switch
                                            checked={service.ros_active}
                                            onChange={(checked) => handleCheckboxChange(service.ros_id, checked)}
                                        />
                                    </Col>
                                </Row>
                            ))}
                        </div>
                    ) : (
                        <List
                            size="small"
                            dataSource={Array.isArray(props.orgServices) ? props.orgServices : []}
                            renderItem={(service) => (
                                <List.Item
                                    style={{
                                        padding: '2px 0',
                                        borderBottom: 'none',  // quita línea divisoria
                                        display: 'flex',
                                        justifyContent: 'flex-start',
                                        alignItems: 'center',
                                    }}
                                >
                                    <span>{service.srv_service}</span>
                                    <Tag
                                        color={service.ros_active ? "green" : "red"}
                                        style={{ marginLeft: 8 }}
                                    >
                                        {service.ros_active ? "Sí" : "No"}
                                    </Tag>
                                </List.Item>
                            )}
                        />
                    )}
                </Col>
            </Row>

            {/* Estado Activo */}
            <Row align="middle" style={{ marginTop: 10 }}>
                <Col span={8}><strong>Organización activa:</strong></Col>
                <Col span={16}>
                    {isEditing ? (
                        <Switch checked={props.orgActive} onChange={props.setOrgActive} />
                    ) : (
                        <Tag
                            color={props.orgActive ? "green" : "red"}
                            style={{ marginLeft: 8 }}
                        >
                            {props.orgActive ? "Sí" : "No"}
                        </Tag>
                    )}
                </Col>
            </Row>

            {/* Botones */}
            <Row justify="end" style={{ marginTop: 20 }}>
                <Space>
                    {isEditing ? (
                        <>
                            <Button type="primary" onClick={handleSaveClick}>Guardar</Button>
                            <Button onClick={() => setIsEditing(false)}>Cancelar</Button>
                        </>
                    ) : (
                        <Button type="default" onClick={handleEditClick}>Editar</Button>
                    )}
                </Space>
            </Row>
        </Form>
    );
};

export default FormOrganization;
